import logo from './logo.svg';
import './App.css';
import Routing from './Routing';
import SideBar from './Menu/SideBar';
import { useLocation } from 'react-router-dom';
import { Suspense, useEffect, useState } from 'react';
import Footer from './Menu/Footer';
import MyHome from './Home/MyHome';


function App() {
  
  return (
    <Suspense>
      <MyHome/>
    </Suspense>
)
}

export default App;
